import { useCallback } from "react";
import { useMappedState } from "redux-react-hook";

import GeneratedVideoMessage from "./components/GeneratedVideoMessage";
import PictureMessage from "./components/PictureMessage";
import VideoMessage from "./components/VideoMessage";


const MediaMessage = (props) => {
  const { message = {},
    onUnblurClick = () => { },
    onZoomClick = () => { },
    setVideoModalState = () => { },
    scenario = {},
    dialog = {},
    game = {},
    batchId,
    setBatches
  } = props;

  const { content = {} } = message;
  const { mediaType, url, blurredUrl, shouldBlur, videoUrl, videoWithSound, genVideoUrl, isNsfw = false } = content;


  const { hasSubscription } = useMappedState(
    useCallback(state => {
      const currentUser = state.users.usersMap.get(state.users.currentUserId);
      const hasSubscription = !!currentUser?.hasSubscription;
      return {
        hasSubscription: hasSubscription
      };
    }, [])
  );

  const isPicture = mediaType === 'picture';
  const hasVideo = Boolean(videoUrl);

  let xUrl = !hasSubscription && shouldBlur ? blurredUrl : url;
  if (!xUrl) xUrl = url;

  const isGeneratedVideo = Boolean(genVideoUrl);

  const showPictureMessage = !hasVideo && isPicture && !isGeneratedVideo;
  const showGeneratedVideoMessage = isGeneratedVideo;

  return (
    <div className="assistant_message_placeholder mt-4 mb-4">
      {showPictureMessage && (
        <PictureMessage
          xUrl={xUrl}
          url={url}
          shouldBlur={shouldBlur}
          onZoomClick={onZoomClick}
          onUnblurClick={onUnblurClick}
          scenario={scenario}
          dialog={dialog}
          game={game}
          batchId={batchId}
          setBatches={setBatches}
        />
      )}
      {showGeneratedVideoMessage && (
        <GeneratedVideoMessage
          url={xUrl}
          videoUrl={genVideoUrl}
          setVideoModalState={setVideoModalState}
          setBatches={setBatches}
          isNsfw={isNsfw}
          onZoomClick={onZoomClick}
        />
      )}
      {hasVideo && (
        <VideoMessage
          xUrl={xUrl}
          videoUrl={videoUrl}
          hasSubscription={hasSubscription}
          shouldBlur={shouldBlur}
          setVideoModalState={setVideoModalState}
          onUnblurClick={onUnblurClick}
          url={url}
          scenario={scenario}
          dialog={dialog}
          game={game}
          videoWithSound={videoWithSound}
        />
      )}
    </div>
  );
};



export default MediaMessage;